import * as React from 'react';
import { Button, ButtonSize, ButtonVariant, XStack } from 'smoothie';

interface EditRuleButtonsProps {
    onSave: () => void;
    onCancel: () => void;
    disableSave?: boolean;
}

const RuleEditorButtons = ({
    onSave,
    onCancel,
    disableSave,
}: EditRuleButtonsProps) => {
    return (
        <XStack gap={12}>
            <Button
                variant={ButtonVariant.SECONDARY}
                size={ButtonSize.LARGE}
                text="Cancel"
                onPress={onCancel}
                buttonProps={{
                    flexShrink: 1,
                }}
            />
            <Button
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.LARGE}
                text="Save"
                onPress={onSave}
                disabled={disableSave}
                buttonProps={{
                    flexShrink: 1,
                }}
            />
        </XStack>
    );
};

export default RuleEditorButtons;
